import { useEffect, useState } from "react";
import {
	upsertAllStrandsData,
	upsertStrandData,
} from "../../repositories/ProductionRepository";
import { useCastersContext } from "../CastersContext";

const useSaveStrand = () => {
	const [error, setError] = useState<string | null>();
	const [sucess, setSucess] = useState<string | null>(null);
	const { state, actions } = useCastersContext();

	const save: (strandId: number, field: string, value: any) => Promise<void> =
		async (strandId, field, value) => {
			if (
				state.processData === null ||
				state.processData.ProcessId === null ||
				(value === null &&
					field !== "ForceHeatsOnHousing" &&
					field !== "ForceHeatsOnMold" &&
					field !== "Pieces")
			)
				return;

			actions.setIsLoadingBackground(true);
			let resp;
			resp = await upsertStrandData(
				state.processData.ProcessId,
				strandId,
				field,
				value,
			);
			actions.setIsLoadingBackground(false);
			if (resp?.ok) setSucess(field + " was saved successfully");
			else setError(resp?.message);
		};

	const saveAllStrands: (field: string, value: any) => Promise<void> = async (
		field,
		value,
	) => {
		if (
			state.processData === null ||
			state.processData.ProcessId === null ||
			(value === null &&
				field !== "ForceHeatsOnHousing" &&
				field !== "ForceHeatsOnMold" &&
				field !== "Pieces")
		)
			return;

		actions.setIsLoadingBackground(true);
		let resp;
		resp = await upsertAllStrandsData(
			state.processData.ProcessId,
			field,
			value,
		);
		actions.setIsLoadingBackground(false);
		if (resp?.ok) setSucess(field + " was saved successfully for all strands");
		else setError(resp?.message);
	};

	useEffect(() => {
		if (sucess) {
			actions.setNotificationMessage(sucess);
			setSucess("");
		}
		if (error) {
			actions.setErrorMessage(error);
			setError(null);
		}
	}, [sucess, error]);
	return { save, saveAllStrands, error, sucess };
};
export { useSaveStrand };
